import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.sixtix.com/v1',
});

export default instance;
